import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import {useCallback, useEffect, useState} from "react";
import {getHarvestUserHoursLastMonth} from "../../utilities/harvestAPI";
import keycloak from "../../Keycloak";




export default function StickyHeadTable({serviceRequestId}) {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [teamMemberHours, setTeamMemberHours] = useState([]);

    const fetchTaskData = useCallback(() => {

        getHarvestUserHoursLastMonth(serviceRequestId, keycloak.token)
            .then((taskInfo) => {
                setTeamMemberHours(taskInfo);
                console.log(taskInfo)
            })
            .catch(error => {
                console.error('Error fetching tasks:', error);
            });
    }, [serviceRequestId]);

    useEffect(() => {
        fetchTaskData();
    }, [fetchTaskData]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden', borderRadius: '15px' }}>
            <div style={{ display: 'flex', alignItems: 'center', overflowX: 'auto' }}>
                <TableContainer sx={{ maxHeight: 440 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={2}>
                                    <TableSticky>
                                        <Typography
                                            variant="body1"
                                            color="text.secondary"
                                            style={{
                                                fontSize: '1.2rem',
                                                fontWeight: 'bold',
                                                background: '#fff',
                                                zIndex: 1,
                                            }}
                                        >
                                            Hours by team member
                                        </Typography>
                                    </TableSticky>
                                </TableCell>
                            </TableRow>
                            {teamMemberHours
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row) => {
                                    const designationsArray = JSON.parse(row.userDesignation);
                                    return (
                                        <React.Fragment key={row.userName}>
                                            <TableRow hover role="checkbox" tabIndex={-1}>
                                                <TableCell>
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                                        <Typography variant="body1">{row.userName}</Typography>
                                                        {designationsArray.map((designation, index) => ( // Map through the parsed array
                                                            <Typography key={index} variant="body2" style={{ fontSize: '0.8rem', color: 'gray' }}>
                                                                {designation}
                                                            </Typography>
                                                        ))}
                                                    </div>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Typography variant="body2" color="text.secondary">
                                                        {row.hours}hrs
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        </React.Fragment>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <div className="pagination-container">
                {teamMemberHours.length >= 5 && (
                    <TablePagination
                        sx={{
                            ".css-pdct74-MuiTablePagination-selectLabel ":{
                            },
                            ".p ":{
                                marginTop: 0,
                                marginBottom: 0
                            },
                            ".MuiTablePagination-toolbar": {
                                order: 2,
                                textAlign: "left",
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            },
                            "& .MuiTablePagination-selectLabel": {
                                order: 0
                            },
                            "& .MuiTablePagination-select": {
                                order: 1,
                                justifyContent: 'space-between',
                            },
                            "& .MuiTablePagination-displayedRows": {
                                order: 3
                            },
                            "& .MuiTablePagination-actions": {
                                order: 4
                            }
                        }}
                        rowsPerPageOptions={[5, 10, 15]}
                        component="div"
                        count={teamMemberHours.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                )}
            </div>
        </Paper>
    );
}

const TableSticky = ({ children }) => (
    <div
        style={{
            position: 'sticky',
            top: 0,
            zIndex: 1,
        }}
    >
        {children}
    </div>
);
